import React from 'react'
import { LOTUS_LOBBY_GROUPS } from '../../constants/lotusCasinoLobbyGroups'
import LotusCasinoLobbyRow from './LotusCasinoLobbyRow'
import '../../apollo-icons.css'
import './LotusCasinoLobby.css'

export type LotusCasinoLobbyProps = {
  preLoginMode?: boolean
  onMoreGames?: (tabIndex: number, groupId?: number) => void
}

const LotusCasinoLobby: React.FC<LotusCasinoLobbyProps> = ({ preLoginMode = false, onMoreGames }) => (
  <div className="lotus-casino-lobby colorful-container cards-container">
    {LOTUS_LOBBY_GROUPS.map((group) => (
      <LotusCasinoLobbyRow
        key={group.id}
        group={group}
        preLoginMode={preLoginMode}
        onMoreGames={onMoreGames}
        mobileLobbyLayout
      />
    ))}
  </div>
)

export default LotusCasinoLobby
